import { ITheme, mediaQuery } from '@quicktools/shared-components';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { loading: boolean }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    root: {
      width: '100%',
      marginBottom: 40,
    },
    label: {
      marginBottom: 12,

      [mediaQuery(breakpoints.tablet)]: {
        padding: [0, 24],
      },
    },
    results: {
      width: '100%',
    },
    buttonContainer: {
      marginBlockStart: 32,
      marginInline: 'auto',
      textAlign: 'center',
      width: 254,

      [mediaQuery(breakpoints.mobile)]: {
        width: 'calc(100% - 48px)',
      },
    },
    loadingIcon: {
      width: 194,

      '&>path': {
        fill: 'var(--x-accent-2-1)',
      },
    },
  }),
  {
    name: 'Results',
  },
);

export default useStyles;
